import { useEffect, useState } from 'react'

import { get } from '../../../utils/api'
import { AnomalyStrategy } from './types'

export type AnomalyStrategies = AnomalyStrategy[]

export const useAnomalyStrategiesData = () => {
  const [anomalyStrategies, setAnomalyStrategies] = useState<AnomalyStrategies>(
    []
  )
  const [
    anomalyStrategyDft,
    setAnomalyStrategyDft,
  ] = useState<AnomalyStrategy>()
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    get<AnomalyStrategies>(`/anomaly_strategies`)
      .then((result) => {
        setAnomalyStrategies(result)
        setAnomalyStrategyDft(
          result.filter((strategy) => strategy.isDefault)[0]
        )
      })
      .finally(() => setLoading(false))
  }, [])

  return {
    anomalyStrategies,
    anomalyStrategyDft,
    anomalyStrategyIsLoading: isLoading,
  }
}
